import Jimp from 'jimp';

export function hello() {
    return "hello";
}

export function closestColor(hex, COLORS, numLayers) {
    //rgba['r']
    const rgba = Jimp.intToRGBA(hex)
    const r = rgba['r'];
    const g = rgba['g'];
    const b = rgba['b'];
    var cr = COLORS[0][0];
    var cg = COLORS[0][1];
    var cb = COLORS[0][2];

    var minIndex = 0;
    var minColorDiff = Math.abs(((r - cr) ** 2) * 0.3 + ((g - cg) ** 2) * 0.59 + ((b - cb) ** 2) * 0.11);

    for (let i = 1; i < numLayers; i++) {
        cr = COLORS[i][0];
        cg = COLORS[i][1];
        cb = COLORS[i][2];

        const colorDiff = Math.abs(((r - cr) ** 2) * 0.3 + ((g - cg) ** 2) * 0.59 + ((b - cb) ** 2) * 0.11);
        // console.log('colorDif, min',colorDiff, ',' ,minColorDiff);

        if (colorDiff <= minColorDiff) {
            minColorDiff = colorDiff;
            minIndex = i;
        }
    }

    return Jimp.rgbaToInt(COLORS[minIndex][0], COLORS[minIndex][1], COLORS[minIndex][2], 1);

}

export function rgbToHex(r, g, b) {
    function componentToHex(c) {

        const hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;

    }
    return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function rgbToHex2(r, g, b)  {
    if (r > 255 || g > 255 || b > 255)
        throw "Invalid color component";
    return ((r << 16) | (g << 8) | b).toString(16);
}
